<template>
    <div class="contact" v-if="$root.dataReady" v-scroll-spy="{offset: -500}">
        <header class="heading">
            <div class="container" v-if="activeLocationData">
                <div class="text">
                    <h1>{{ activeLocationData.city && activeLocationData.city }}</h1>
                </div>
                <StickyNavigation :navigationLinks="stickyMenuTabs"></StickyNavigation>
            </div>
            <div
                v-if="activeLocationData"
                class="bg"
                :style="{ 'background-image': 'url( '+ activeLocationData.image.url +' )' }"
            ></div>
        </header>
        <template>
            <pictured-section :data="locationInfo" id="link-0" />
            <key-contacts :activeLocationData="activeLocationData" />
            <contact-map :locationData="activeLocationData" id="link-1" />
            <awards-slider-contact-location :data="activeLocationData.awards" id="link-2" />
        </template>
    </div>
</template>

<script>
import StickyNavigation from "../components/StickyNavigation";
import Block from "../components/Block.vue";
import OurWorkSlider from "../components/OurWorkSlider.vue";
import ChangeSection from "../components/ChangeSection.vue";
import PartnersSlider from "../components/PartnersSlider.vue";
import BlockMap from "../components/BlockMap.vue";
import ImageWrapper from "../components/ImageWrapper.vue";
import OurPeopleSlider from "../components/OurPeopleSlider.vue";
import VideoWrapper from "../components/VideoWrapper.vue";
import ContactMap from "../components/ContactMap.vue";
import AwardsSlider from "../components/AwardsSlider.vue";
import RegionalOffices from "../components/RegionalOffices.vue";
import KeyContacts from "../components/KeyContacts.vue";
import PicturedSection from "../components/PicturedSection";
import AwardsSliderContactLocation from "../components/AwardsSliderContactLocation";
import BlockCmgGreenhouse from "../components/BlockCmgGreenhouse.vue";

export default {
    name: "simple-page",
    data() {
        let currMenuTabs = [
            {
                name: "Overview"
            },
            {
                name: "Get in touch"
            },
            {
                name: "Awards"
            }
        ];
        if (this.$root.apiLang == "de") {
            currMenuTabs = [
                {
                    name: "ÜBERBLICK"
                },
                {
                    name: "SPRECHEN SIE MIT UNS"
                }
            ];
        }
        if (this.$root.apiLang == "africa") {
            currMenuTabs = [
                {
                    name: "Overview"
                },
                {
                    name: "Get in touch"
                }
            ];
        }
        if (this.$root.apiLang == "mena") {
            currMenuTabs = [
                {
                    name: "GENEL BAKIŞ"
                },
                {
                    name: "İLETİŞİME GEÇİN"
                }
            ];
        }
        if (this.$root.apiLang == "se") {
          currMenuTabs = [
            {
              name: "OM UNITED MINDS"
            },
            {
              name: "KONTAKTA OSS"
            }
          ];
        }
        return {
            locationData: null,
            blocks: null,
            page: null,
            activeLocation: 0,
            stickyMenuTabs: currMenuTabs
        };
    },
    components: {
        StickyNavigation,
        Block,
        OurWorkSlider,
        ChangeSection,
        PartnersSlider,
        BlockMap,
        ImageWrapper,
        OurPeopleSlider,
        VideoWrapper,
        ContactMap,
        AwardsSlider,
        RegionalOffices,
        KeyContacts,
        PicturedSection,
        AwardsSliderContactLocation,
        BlockCmgGreenhouse
    },
    created: function() {
        this.$root.dataReady = false;
        this.$root.headeriswhite = true;
    },
    mounted: function() {
        this.fetchData();
    },
    computed: {
        activeLocationData: function() {
            return this.locationData[this.activeLocation];
        },
        locationInfo: function() {
            return this.locationData[this.activeLocation].location_info;
        }
    },
    props: ["slug"],
    methods: {
        fetchData: function() {
            var self = this;
            $.get(
                self.$root.apiUrl + "wp-json/wp/v2/pages?slug=" + self.slug,
                function(response) {
                    if (response.length < 1) {
                        self.$router.push("/");
                    }
                    self.blocks = response[0].acf.block_grid;
                    self.locationData =
                        response[0].acf.block_grid[0]["maps-repeater"];

                    self.page = response[0];
                    self.$root.dataReady = true;
                }
            )
                .done(function() {
                    self.setActiveLocation();
                    self.setTitle(self.activeLocationData.city);
                })
                .fail(function() {});
        },
        setTitle: function(title) {
            title = title.normalize('NFD').replace("&#038;", "&");
            document.title = title + " - Weber Shandwick";
        },
        setActiveLocation: function(newActiveLocation) {
            if (newActiveLocation) {
                this.activeLocation = newActiveLocation;
            } else {
                this.activeLocation = this.getActiveLocationID(
                    this.$route.params.location
                );
            }
        },
        getActiveLocationID: function(activeCitySlug) {
            var activeLocationID = 0;
            $.each(this.locationData, function(key, value) {
                if (value.city_slug === activeCitySlug) {
                    activeLocationID = key;
                }
            });
            return activeLocationID;
        }
    }
};
</script>



// WEBPACK FOOTER //
// SimplePage.vue?06c90f0e